const _excluded = ["menuItems", "getItemProps", "renderMenuItem", "selectedItems", "highlightedIndex", "addSelectedItem", "removeSelectedItem", "children"],
  _excluded2 = ["item"],
  _excluded3 = ["style", "isSelected"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { Menu, MenuItem } from '../layout';
/**
 * @deprecated Single and Multi select menus have been combined.  Use DropdownMenu instead
 */
const MultiSelectMenu = _ref => {
  let {
      menuItems,
      getItemProps,
      renderMenuItem = _ref2 => {
        let {
            item
          } = _ref2,
          itemProps = _objectWithoutProperties(_ref2, _excluded2);
        return /*#__PURE__*/React.createElement(MenuItem, _extends({}, itemProps, {
          text: item.label,
          subtext: item.subtext
        }));
      },
      selectedItems,
      highlightedIndex,
      addSelectedItem,
      removeSelectedItem,
      children
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Menu, props, menuItems.map((item, index) => {
    const _ref3 = (getItemProps === null || getItemProps === void 0 ? void 0 : getItemProps({
        item
      })) || {},
      {
        style,
        isSelected
      } = _ref3,
      itemProps = _objectWithoutProperties(_ref3, _excluded3);
    return renderMenuItem(_objectSpread(_objectSpread({
      key: index,
      style: style
    }, itemProps), {}, {
      onClick: () => {
        isSelected ? removeSelectedItem(item) : addSelectedItem(item);
      },
      item,
      isMultiple: true,
      isHighlighted: highlightedIndex === index,
      isSelected
    }));
  }), children);
};
export default MultiSelectMenu;
//# sourceMappingURL=MultiSelectMenu.js.map